import React from 'react';
import './Testimonials.css';

const testimonials = [
  {
    stars: '★★★★★',
    quote: '"Booked at 9pm, creator arrived at 11am. My product launch reel hit 400K views in 48 hours. GoSnap is literally magic."',
    avatar: '👩',
    name: 'Meera Kapoor',
    handle: '@meera.creates · 280K followers',
    delay: '',
  },
  {
    stars: '★★★★★',
    quote: '"Used GoSnap for our restaurant launch. Four reels in one session. Instagram went from 500 to 12K followers in 3 weeks."',
    avatar: '👨',
    name: 'Ravi Teja Goud',
    handle: 'Spice Garden, Jubilee Hills',
    delay: 'rd1',
  },
  {
    stars: '★★★★★',
    quote: '"The quality blew me away. Unbelievable value for what we paid. Same quality as top brands — at a fraction of the cost."',
    avatar: '👩',
    name: 'Ananya Rao',
    handle: 'Brand Manager, Lotus Retail',
    delay: 'rd2',
  },
  {
    stars: '★★★★★',
    quote: '"As a creator, GoSnap changed my life. I do 15+ bookings a month and earn more than my 9-to-5 ever paid."',
    avatar: '🎥',
    name: 'Suresh Varma',
    handle: 'GoSnap Creator · Hyderabad',
    delay: '',
  },
  {
    stars: '★★★★★',
    quote: '"Our wedding highlight reel was ready the same evening. Our families watched it together that night. Absolutely priceless."',
    avatar: '💍',
    name: 'Divya & Karthik',
    handle: 'GoSnap Wedding Client',
    delay: 'rd1',
  },
  {
    stars: '★★★★★',
    quote: '"Replaced our entire content agency with two GoSnap retainer creators. Same quality, one-fifth the cost."',
    avatar: '💼',
    name: 'Naveen Kumar',
    handle: 'CEO, FreshBox Delivery',
    delay: 'rd2',
  },
];

const Testimonials = () => (
  <section className="testimonials" id="testimonials">
    <div className="container">
      <div className="testi-head reveal">
        <span className="sec-label">Real results</span>
        <h2 className="sec-h2">Creators Love It.<br /><em>Clients</em> Love It More.</h2>
      </div>
      <div className="testi-grid">
        {testimonials.map((t, i) => (
          <div key={i} className={`testi-card reveal ${t.delay}`}>
            <div className="testi-stars">{t.stars}</div>
            <p className="testi-q">{t.quote}</p>
            <div className="testi-author">
              <div className="testi-ava">{t.avatar}</div>
              <div>
                <div className="testi-name">{t.name}</div>
                <div className="testi-handle">{t.handle}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Testimonials;
